import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useRelatedEntity from '@hooks/useRelatedEntity'

import type { RelatedEntityModel } from '@models/types'

// @ts-expect-error TS2614
import type { Subject } from '@functions/relatedEntity'

// @ts-expect-error TS7006
const confirmDelete = (deleteRelatedEntity, deleteFn) => {
  const deleteRelatedEntityPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Connection Deleted',
  }

  swal
    .fire({
      title: 'Delete Connection?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deleteRelatedEntity(deleteRelatedEntityPayload)
      }
    })
}

const getTitle = (params: { relatedEntity: RelatedEntityModel, subject: Subject }) => {
  const { relatedEntity, subject } = params

  if (subject?.settings?.callbacks?.getLabel){
    const { settings: { callbacks: { getLabel } } } = subject
    return getLabel(relatedEntity)
  }

  return `${subject?.title} - #${subject?.id}`
}

const getAdvancedLabel = (params: { relatedEntity: RelatedEntityModel, subject: Subject }) => {
  const { relatedEntity, subject } = params

  if (subject?.settings?.callbacks?.getAdvancedLabel){
    const { settings: { callbacks: { getAdvancedLabel: getAdvancedLabelFn } } } = subject
    return getAdvancedLabelFn(relatedEntity)
  }

  return ''
}

interface RelatedEntityListItemProps {
  callbacks: {
    deleteRelatedEntity: () => void,
  },
  relatedEntity: RelatedEntityModel,
  subject: Subject,
}

const RelatedEntityListItem = (props: RelatedEntityListItemProps) => {
  const { callbacks: { deleteRelatedEntity }, relatedEntity, subject } = props

  const relatedEntityPayload = useRelatedEntity(relatedEntity)
  const {
    callbacks: {
      createOrEditRelatedEntity,
      deleteRelatedEntity: deleteFn,
    },
  } = relatedEntityPayload

  const advancedLabel = getAdvancedLabel({ relatedEntity, subject })

  return (
    <DashboardModuleListItem
      secondaryText={advancedLabel || subject?.settings?.label}
      title={getTitle({ relatedEntity, subject })}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon marginRight="medium" onClick={() => createOrEditRelatedEntity()} type="edit" />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteRelatedEntity, deleteFn)}
          type="delete"
        />
      {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default RelatedEntityListItem
